exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "[data-v-d2450fae].van-field__label{color:#2b2c2c;text-align:left;word-wrap:break-word;font-size:15px;margin-bottom:8px}[data-v-d2450fae].van-field__body{font-size:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d2450fae","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/user/Index.vue
// module id = 403
// module chunks = 1